module.exports = __webpack_public_path__ + "img/Westcon yards logo.35a9f0c2.svg";